<template>
    <div class="way">
        <div class="way-content">
            <h2>联系我们</h2>
            <img src="../../static/images/contact_way.png" alt="">
            <div>
                <h4>电话咨询请致电</h4>
                <p>电话&nbsp;{{wayInfo.phone}}</p>
                <span>工作时间&nbsp;:&nbsp;{{wayInfo.worktime}}</span>
                <ul>
                    <li>地址&nbsp;:&nbsp;{{wayInfo.address}}</li>
                    <li>邮箱&nbsp;:&nbsp;{{wayInfo.email}}</li>
                    <li>网址&nbsp;:&nbsp;{{wayInfo.url}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Way',
    props: {
        wayInfo: Object
    },
    mounted () {
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    .way
        width: 100%
        .way-content
            width: 100%
            padding: 0.92rem 14% 1.14rem
            box-sizing: border-box
            overflow: hidden
            h2
                text-align: center
                color: #333
                font-size: 0.4rem
                font-weight: 800
                margin-bottom: 0.38rem
                letter-spacing: 1px
            img
                width: 100%
            div
                width: 100%
                margin-top: 0.62rem
                h4
                    font-weight: 800
                    color: #333
                    font-size: 0.28rem
                    &:after
                        display: block
                        margin-top: 0.16rem
                        content:''
                        border-bottom: 1px solid $yellow
                        width: 0.74rem
                p
                    font-size: 0.4rem
                    font-weight: 800
                    color: #000
                    margin: 0.48rem 0 0.16rem
                    letter-spacing: 1px
                span
                    font-size: 0.22rem
                    color: #666
                ul
                    margin-top: 0.52rem
                    font-size: 0.24rem
                    color: #333
                    line-height: 1.8em
</style>


// WEBPACK FOOTER //
// src/components/mobile/ContactWay.vue